/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react'
import { Redirect } from 'react-router-dom'
import LandingPage from './containers/LandingPage/LandingPage'
import ErrorLayout from './layouts/Error'
import DashboardLayout from './layouts/Dashboard'
import SignIn from './containers/auth/SignIn'
import SignUp from './containers/auth/SignUp'

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <LandingPage />
  },
  {
    path: '/signin',
    exact: true,
    component: () => <SignIn />
  },
  {
    path: '/signup',
    exact: true,
    component: () => <SignUp />
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('views/client/Error401'))
      },
      {
        path: '/errors/client-error',
        exact: true,
        component: lazy(() => import('views/client/ErrorClient'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('views/client/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('views/client/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('views/client/Dashboard'))
      },
      {
        path: '/analytics',
        exact: true,
        component: lazy(() => import('views/client/Analytics'))
      },
      {
        path: '/brands',
        exact: true,
        component: lazy(() => import('views/client/Brands'))
      },
      {
        path: '/admin-analytics',
        exact: true,
        component: lazy(() => import('views/admin/AdminAnalytics'))
      },
      {
        path: '/active-videos',
        exact: true,
        component: lazy(() => import('views/admin/ActiveVideos'))
      },
      {
        path: '/pending-accounts',
        exact: true,
        component: lazy(() => import('views/admin/PendingAccounts'))
      },
      {
        path: '/manage-accounts',
        exact: true,
        component: lazy(() => import('views/admin/ManageAccounts'))
      },
      {
        path: '/pending-campaigns',
        exact: true,
        component: lazy(() => import('views/admin/PendingCampaigns'))
      },
      {
        path: '/manage-campaigns',
        exact: true,
        component: lazy(() => import('views/admin/ManageCampaigns'))
      },
      {
        path: '/manage-prices',
        exact: true,
        component: lazy(() => import('views/admin/ManagePrices'))
      },
      {
        path: '/assets',
        exact: true,
        component: lazy(() => import('views/client/AssetsAndMedia'))
      },
      {
        path: '/transactions',
        exact: true,
        component: lazy(() => import('views/client/Transactions'))
      },
      {
        path: '/account',
        exact: true,
        component: lazy(() => import('views/client/Account'))
      },
      {
        path: '/admins',
        exact: true,
        component: lazy(() => import('views/client/Admins'))
      },
      {
        path: '/supportcenter',
        exact: true,
        component: lazy(() => import('views/client/SupportCenter'))
      },
      {
        path: '/helpcenter',
        exact: true,
        component: lazy(() => import('views/client/HelpCenter'))
      },
      {
        path: '/notifications',
        exact: true,
        component: lazy(() => import('views/client/Notifications'))
      },
      {
        path: '/report',
        exact: true,
        component: lazy(() => import('views/client/ReportIssue'))
      },
      {
        path: '/newcampaign',
        exact: true,
        component: lazy(() => import('views/client/NewCampaign'))
      },
      {
        path: '/renew-campaign',
        exact: true,
        component: lazy(() => import('views/client/RenewCampaign'))
      },
      {
        path: '/endcampaign',
        exact: true,
        component: lazy(() => import('views/client/End'))
      },
      {
        path: '/end-renew-campaign',
        exact: true,
        component: lazy(() => import('views/client/End/EndRenewCampaign'))
      },
      {
        path: '/campaigns',
        exact: true,
        component: lazy(() => import('views/client/Campaigns'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
]

export default routes
